export default __webpack_public_path__ + "static/media/certificates_summary.ba3ad993.jpg";